const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_submission-intake/artifacts/57ewljr4_BSG%20WHITE%20LOGO%20%281%29%20%281%29.jpeg";

/**
 * BSG Investments brand mark.
 * The source logo has a white background, so we render it inside a slim white
 * rounded tile with a subtle gold ring — looks intentional on the dark-blue UI.
 */
export default function BrandLogo({ size = "md", className = "", testId = "brand-logo" }) {
    const dims =
        size === "lg"
            ? { wrap: "h-14 px-3", img: "h-12" }
            : size === "sm"
            ? { wrap: "h-8 px-2", img: "h-6" }
            : { wrap: "h-10 px-2.5", img: "h-9" };
    return (
        <div
            className={`inline-flex items-center justify-center rounded-lg bg-white ring-1 ring-[#D4AF37]/40 shadow-[0_0_18px_rgba(212,175,55,0.18)] ${dims.wrap} ${className}`}
            data-testid={testId}
        >
            <img src={LOGO_URL} alt="BSG Investments" className={`${dims.img} w-auto object-contain`} />
        </div>
    );
}
